// extracted by mini-css-extract-plugin
export default {"toDoItem":"ToDoItem_toDoItem__ZmFIF","completed":"ToDoItem_completed__TqOdK"};